export {};

const wrongEmailDomains = [
    {
        correct: '@gmail.com',
        wrong: [
            '@gmail.si',
            '@gmai.com',
            '@gmail.con',
            '@gmal.com',
            '@gmil.com',
            '@gmail.co',
            '@gmail.comm',
            '@gamil.com',
            '@gmsil.com',
            '@gnail.com',
            '@gmeil.com',
            '@gemail.com',
            '@gmail.cim',
            '@gmial.com',
            '@gmail.vom',
            '@gmali.com',
            '@gmail.comom',
            '@gmajl.com',
            '@hmail.com',
            '@gmail.net',
            '@gmaul.com',
            '@gmail.com.com',
            '@gmail.om',
            '@gmaill.com',
            '@gmail.com1',
            '@gmail.cm',
            '@gail.com',
            '@gmail.cpm',
            '@gmail.c',
            '@gmail.kom',
            '@gmaol.com',
            '@gmail.cok',
            '@gmail.co.com',
            '@gmail.coom',
            '@gmail.commm',
            '@gmaiil.com',
            '@gemal.com',
            '@gmail.coml',
            '@gmail.coma',
            '@gma.com',
            '@gmail'
        ]
    }
];

document.addEventListener('started', () => {
    app.html.setFocus('#email');

    // Make sure parameters like "?provider=telemach&code=123" are preserved
    const form = app.html.q('form') as HTMLFormElement | null;
    if (form) {
        form.action += document.location.search;
    }

    app.html.q('altcha-widget')?.addEventListener('statechange', (ev: any) => {
        const state = ev.detail.state;

        if (state === "verifying") {
            app.html.q('submit-button')?.setAttribute('loading', '');
        } else if (state === "verified" || state === "error") {
            app.html.q('submit-button')?.removeAttribute('loading');
        }
    });
});

// Check if entered email is valid. Stop sumit event if it is not.
function submitCheckEmail(event: Event): void {
    if (!window.app) {
        return;
    }

    const form = event.target as HTMLFormElement;
    const emailInput = app.html.q('#email', form) as HTMLInputElement | null;
    if (!emailInput) {
        return;
    }

    const errorEl = app.html.q('.login-error', form);
    const email = emailInput.value || '';
    const atIndex = email.lastIndexOf('@');
    const domain = atIndex === -1 ? '' : email.substring(atIndex);

    if (domain.length <= 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showEmailError(errorEl, '{{ T "access.check_email.emailRequired" }}');
        return;
    }

    const wrongMatch = wrongEmailDomains.find(d => d.wrong.includes(domain));
    if (wrongMatch) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const suggestedEmail = email.slice(0, atIndex) + wrongMatch.correct;
        showEmailError(errorEl, '{{ T "access.check_email.wrongEmailDomain" }}'.replace('{email}', suggestedEmail));
        return;
    }

    // With altcha the spinner is started by the widget's "verifying" state, without
    // it nothing else would show that the form is being submitted.
    if (!config.enableAltcha) {
        app.html.q('submit-button')?.setAttribute('loading', '');
    }
}

// The button is always enabled - all validation happens on submit. Typing here
// just clears any previously shown error so it doesn't linger while the user edits.
function onInput(event: Event): void {
    if (!window.app) {
        return;
    }

    const form = app.html.q('form') as HTMLFormElement | null;
    if (!form) {
        return;
    }

    clearEmailError(app.html.q('.login-error', form));
}

function showEmailError(errorEl: HTMLElement | null, message: string): void {
    if (!errorEl) {
        return;
    }

    app.html.writeHTML(errorEl, message);
    app.html.show(errorEl);

    // Stop submit-button spinner
    app.html.q('submit-button')?.removeAttribute('loading');
}

function clearEmailError(errorEl: HTMLElement | null): void {
    if (!errorEl) {
        return;
    }

    app.html.writeHTML(errorEl, '');
    app.html.hide(errorEl);
}

window.onInput = onInput;
window.submitCheckEmail = submitCheckEmail;
